import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d468190"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-reply" }, null, -1))
const _hoisted_6 = { class: "card-body p-9" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-6d468190><div class=\"d-flex\" data-v-6d468190><label class=\"fw-bold text-muted text-nowrap\" data-v-6d468190> Đơn vị:............................. </label><h2 class=\"w-100 text-center pr-120\" data-v-6d468190> CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM </h2></div></div><div class=\"row mb-5\" data-v-6d468190><div class=\"d-flex\" data-v-6d468190><label class=\"fw-bold text-muted text-nowrap\" data-v-6d468190> Bộ phận:............................. </label><h2 class=\"w-100 text-center pr-120\" data-v-6d468190>Độc lập - Tự do - Hạnh phúc</h2></div></div><div class=\"row\" data-v-6d468190><h2 class=\"col text-center\" data-v-6d468190>Biên bản giải thể</h2></div>", 3)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col text-center" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "d-flex text-center align-items-center justify-content-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold text-muted d-flex align-items-center" }, "Tên thiết bị:", -1))
const _hoisted_19 = { class: "col-9" }
const _hoisted_20 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = { class: "row d-flex align-items-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold text-muted d-flex align-items-center" }, "Số hiệu:", -1))
const _hoisted_24 = { class: "col-lg-9" }
const _hoisted_25 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = { class: "row d-flex align-items-center" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold text-muted d-flex align-items-center" }, "Tên kế hoạch:", -1))
const _hoisted_31 = { class: "col-9" }
const _hoisted_32 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_33 = { class: "col-6" }
const _hoisted_34 = { class: "row d-flex align-items-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold text-muted d-flex align-items-center" }, "Ngày vào xưởng", -1))
const _hoisted_36 = { class: "col-8" }
const _hoisted_37 = { class: "card-body p-9" }
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"row mt-10\" data-v-6d468190><div class=\"col-4 text-center\" data-v-6d468190><label class=\"fw-bolder text-nowrap\" data-v-6d468190>Kỹ thuật viên</label></div><div class=\"col-4 text-center\" data-v-6d468190><label class=\"fw-bolder text-nowrap\" data-v-6d468190> Quản đốc (phân đoạn trưởng) </label></div><div class=\"col-4 text-center\" data-v-6d468190><label class=\"fw-bolder text-nowrap\" data-v-6d468190>Giám đốc</label></div></div><div class=\"row mb-20\" data-v-6d468190><div class=\"col-4 text-center\" data-v-6d468190><label class=\"text-nowrap\" data-v-6d468190>(Ký, họ tên)</label></div><div class=\"col-4 text-center\" data-v-6d468190><label class=\"text-nowrap\" data-v-6d468190>(Ký, họ tên)</label></div><div class=\"col-4 text-center\" data-v-6d468190><label class=\"text-nowrap\" data-v-6d468190>(Ký, họ tên)</label></div></div><br data-v-6d468190><br data-v-6d468190><br data-v-6d468190>", 5)
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "pl-4" }
const _hoisted_45 = { class: "form-check" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Ngoài định mức ", -1))
const _hoisted_47 = { key: 0 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_DissolutionReportTable = _resolveComponent("DissolutionReportTable")!
  const _component_DissolutionReportTableAdd = _resolveComponent("DissolutionReportTableAdd")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.isCreating ? "Tạo mới" : "Chỉnh sửa") + " biên bản giải thế ", 1)
      ]),
      _createVNode(_component_router_link, {
        to: "/quan-ly/bien-ban-giai-the",
        class: "btn btn-primary align-self-center"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h5", _hoisted_11, " Ngày " + _toDisplayString(new Date().getDate()) + " tháng " + _toDisplayString(new Date().getMonth() + 1) + " năm " + _toDisplayString(new Date().getFullYear()), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h5", _hoisted_13, [
          _createTextVNode(" Biên bản số: "),
          _createVNode(_component_el_input, {
            class: "d-inline w-20 mx-2",
            modelValue: _ctx.reportNumber,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reportNumber) = $event))
          }, null, 8, ["modelValue"]),
          _createTextVNode(" / TĐM ")
        ])
      ]),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.productItem && _ctx.productItem.ten_san_pham), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.productItem && _ctx.productItem.so_hieu), 1)
            ])
          ])
        ])
      ]),
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.planName), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.factoryDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.factoryDate) = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createVNode(_component_DissolutionReportTable, { items: _ctx.selectedSupplies }, null, 8, ["items"]),
      _hoisted_38,
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.outSupplies) = $event)),
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, _ctx.outSupplies]
            ]),
            _hoisted_46
          ])
        ])
      ]),
      (_ctx.outSupplies)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _createVNode(_component_DissolutionReportTableAdd, {
              ref: "tableOutDissolution",
              isEdit: _ctx.isCreating
            }, null, 8, ["isEdit"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_48,
      _createElementVNode("button", {
        class: "btn btn-lg btn-primary ml-auto d-block mt-4",
        type: "submit",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)))
      }, " Lưu ")
    ])
  ]))
}